import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { WarningCircle } from '@phosphor-icons/react';
import './style';

const Input = forwardRef((props, ref) => {
  const {
    value,
    disabled,
    contentLeft,
    iconLeft,
    label,
    labelIcon,
    onChange,
    width,
    validationStatus,
    helpText,
    className,
    required,
    contentRight,
    ...attr
  } = props;

  return (
    <div
      className={`input-container flex flex-col gap-2 ${className}`}
      {...(width && ({ style: { width } }))}
    >
      {label && (<label
        className={`label flex items-center gap-1.5 label-16 ${required ? 'required' : ''}`}
        htmlFor="input-field"
      >
        {label}
        {labelIcon}
      </label>)}
      <div className="input-field-wrapper shadow-xs flex relative">
        {contentLeft && (
          <div className="input-content-left flex items-center justify-center">
            <span className="content label-16 w-full px-6 py-2.5">{contentLeft}</span>
          </div>
        )}
        <input
          name="input-field"
          className={`input-field label-16 w-full py-3 px-5`
            + `${contentLeft ? ' content-left' : ''}`
            + `${validationStatus ? ` ${validationStatus} content-right` : ''}`
            + `${iconLeft ? ' icon-left' : ''}`
          }
          value={value}
          disabled={disabled}
          onChange={onChange}
          ref={ref}
          {...attr}
        />
        {iconLeft && (
          <div className={`${window.innerWidth < 768 ? 'input-icon-left-mobile' : 'input-icon-left'} h-full flex items-center justify-center absolute`}>
            <span className="content">{iconLeft}</span>
          </div>
        )}
        {(validationStatus === 'error') && (
          <div className="input-content-right icon flex items-center justify-center absolute">
            <div className="content"><WarningCircle size={26}
              color="#D92D20"
              weight="fill" /></div>
          </div>
        )}
        {contentRight && (
          <div className="input-content-right flex items-center justify-center absolute">
            <span className="content label-16 w-full py-2.5">{contentRight}</span>
          </div>
        )}
      </div>
      {helpText && <div className={`help-text text-12 ${validationStatus === 'error' ? 'text-error' : 'text-grey-70'}`}>{helpText}</div>}
    </div>
  );
});

Input.propTypes = {
  value: PropTypes.string,
  disabled: PropTypes.bool,
  contentLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  contentRight: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  iconLeft: PropTypes.element,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  labelIcon: PropTypes.element,
  onChange: PropTypes.func,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  validationStatus: PropTypes.string,
  helpText: PropTypes.string,
  className: PropTypes.string,
};

Input.defaultProps = {
  value: null,
  disabled: false,
  contentLeft: null,
  contentRight: null,
  iconLeft: null,
  label: null,
  labelIcon: null,
  onChange: () => null,
  width: 640,
  validationStatus: null,
  helpText: null,
  className: '',
};

export default Input;
